package ui

import dataOwners
import dev.gitlive.firebase.firestore.toMilliseconds
import js.intl.DateTimeFormat
import js.objects.jso
import react.*
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.img
import react.dom.html.ReactHTML.span
import routes.EnumRoutes
import ui.components.DashboardIcon
import ui.components.DataSidebarMenu
import ui.components.InquiriesIcon
import ui.components.ListingsIcon
import ui.components.NavBar
import ui.components.OwnerSubmissionsIcon
import ui.components.ScheduleIcon
import web.cssom.*
import kotlin.js.Date

// New Props interfaces for Owner Submissions page
external interface SubmissionRowProps : Props {
    var name: String?
    var property: String?
    var location: String?
    var submitted: String?
    var status: String?
    var avatar: String?

}

// SubmissionRow Component (new component specific to Owner Submissions)
val SubmissionRow = FC<SubmissionRowProps> { props ->
    div {
        className = ClassName("flex justify-center items-start gap-4 border-b border-gray-200 py-4")

        // Name column
        div {
            className = ClassName("flex-1 flex items-center gap-3")
            img {
                src = props.avatar
                alt = props.name
                className = ClassName("w-8 h-8 rounded-full")
            }
            div {
                className = ClassName("text-sm font-normal text-black")
                style = jso<CSSProperties> {
                    fontFamily = string("Century Schoolbook, serif")
                }
                +props.name
            }
        }

        // Property column
        div {
            className = ClassName("flex-1 flex items-center")
            div {
                className = ClassName("text-sm font-normal text-black")
                style = jso<CSSProperties> {
                    fontFamily = string("Century Schoolbook, serif")
                }
                +props.property
            }
        }

        // Location column
        div {
            className = ClassName("flex-1 flex items-center")
            div {
                className = ClassName("text-sm font-normal text-black")
                style = jso<CSSProperties> {
                    fontFamily = string("Century Schoolbook, serif")
                }
                +props.location
            }
        }

        // Submitted date column
        div {
            className = ClassName("flex-1 flex items-center")
            div {
                className = ClassName("text-sm font-normal text-black")
                style = jso<CSSProperties> {
                    fontFamily = string("Century Schoolbook, serif")
                }
                +props.submitted
            }
        }

        // Status column
        div {
            className = ClassName("flex-1 flex items-center")
            div {
                className = ClassName("text-sm font-normal text-black")
                style = jso<CSSProperties> {
                    fontFamily = string("Century Schoolbook, serif")
                }
                +props.status
            }
        }
    }
}

// Main Owner Submissions Component
val OwnerSubmissions = FC<Props> {
    var isSidebarOpen by useState(false)
    var activeTab by useState("All")

    // Submissions data
    val submissionsData = dataOwners

    div {
        className = ClassName("min-h-screen bg-white flex relative")

//        Side Navigation
        NavBar{
            this.activeNavItem = "Owner Submissions"
        }


        // Main Content
        div {
            className = ClassName("flex-1 p-4 lg:p-6 ml-0 lg:ml-0")

            // Breadcrumb
            div {
                className = ClassName("flex items-center gap-2 mb-6 mt-16 lg:mt-0")
                button {
                    className = ClassName("text-sm font-normal text-black hover:text-boon-primary")
                    onClick = {
                        // Handle navigation to Dashboard
                        console.log("Navigate to Dashboard")
                    }
                    +"Dashboard"
                }
                span {
                    className = ClassName("text-sm font-normal text-boon-gray")
                    +">"
                }
                span {
                    className = ClassName("text-sm font-normal text-black")
                    +"Owner Submissions"
                }
            }

            // Page Title
            div {
                className = ClassName("text-center mb-6")
                h1 {
                    className = ClassName("text-xl lg:text-2xl font-normal text-boon-primary")
                    +"Owner Submissions"
                }
            }

            // Tab Navigation (using TabItem from Inquiries conversion)
            div {
                className = ClassName("flex items-start gap-5 border-b border-gray-200 mb-6")

                TabItem {
                    label = "All"
                    isActive = (activeTab == "All")
                    onClick = { activeTab = "All" }
                }
                TabItem {
                    label = "Pending"
                    isActive = (activeTab == "Pending")
                    onClick = { activeTab = "Pending" }
                }
                TabItem {
                    label = "Approved"
                    isActive = (activeTab == "Approved")
                    onClick = { activeTab = "Approved" }
                }
                TabItem {
                    label = "Rejected"
                    isActive = (activeTab == "Rejected")
                    onClick = { activeTab = "Rejected" }
                }
            }

            // Submission List Title
            div {
                className = ClassName("text-center mb-6")
                h2 {
                    className = ClassName("text-lg lg:text-xl font-normal text-black")
                    +"Submission List"
                }
            }

            // Table Header
            div {
                className = ClassName("flex justify-center items-start gap-4 mb-4")
                div {
                    className = ClassName("flex-1 text-left")
                    div {
                        className = ClassName("text-sm font-normal text-black px-3")
                        +"Name"
                    }
                }
                div {
                    className = ClassName("flex-1 text-left")
                    div {
                        className = ClassName("text-sm font-normal text-black px-3")
                        +"Property"
                    }
                }
                div {
                    className = ClassName("flex-1 text-left")
                    div {
                        className = ClassName("text-sm font-normal text-black px-3")
                        +"Location"
                    }
                }
                div {
                    className = ClassName("flex-1 text-left")
                    div {
                        className = ClassName("text-sm font-normal text-black px-3")
                        +"Submitted"
                    }
                }
                div {
                    className = ClassName("flex-1 text-left")
                    div {
                        className = ClassName("text-sm font-normal text-black px-3")
                        +"Status"
                    }
                }
            }



            // Submissions Data
            div {
                className = ClassName("space-y-0")

                submissionsData.forEach { submission ->
                    SubmissionRow {
                        name = "${submission.firstName} ${submission.lastName}"
                        property = submission.propertyTitle.toString()
                        location = submission.location
                        submitted = Date(submission.timestamp!!.toMilliseconds()).toString()
//                        status = submission.status
//                        avatar = submission.avatar
                    }
                }
            }
        }
    }
}